import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import BaseUrl from "../../base-api";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

export default function RegistrationForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const [allData, setAllData] = useState({});
  const [employeeData, setEmployeeData] = useState([]);
  const [twelthData, setTwelthData] = useState([]);
  const [modal, setModal] = useState(false);
  const [courses, setCourses] = useState([]);
  const [infoData, setInfoData] = useState({});
  const [alreadySubmitted, setAlreadySubmitted] = useState(true);
  const [resubmission, setResubmission] = useState(false);
  const [year, setYear] = useState([]);
  const [month, setMonth] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [boards, setBoards] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [ndocuments, setNdocuments] = useState([]);
  const [isEmployee, setIsEmployee] = useState(false);
  const containerRef = useRef(null);
  const canvasRef = useRef(null);
  const [approveStatus, setApproveStatus] = useState("");
  const [imageBlob, setImageBlob] = useState(null);
  const [mobileNumber, setMobileNumber] = useState('');

  useEffect(() => {
    const { status } = location.state || {};
    if (status) {
      setMobileNumber(status);
    } else {
      console.warn('Status not found in location state, using default status.');
    }
  }, [location.state]);

  useEffect(() => {
    if (!mobileNumber) return;


    axios
      .get(`${BaseUrl}/reg/viewApplication`, {
        headers: {
          Authorization: localStorage.getItem("$3ingT0k3n"),
        },
        params: {
          mobileNumber,
        },
      })


      .then((response) => {
        const { data } = response;
        setInfoData(data);

      })
      .catch((error) => {
        toast.error(error.message || "An error occurred");
      })
  }, [mobileNumber]);

  const [formData, setFormData] = useState({
    approval: "",
    remarks: "",
  });

  const toggle = () => setModal(!modal);
  const [array, setArray] = useState({
    applicantName: "",
    applicationStatus: "",
    course: "",
    mobileNumber: "",
  });

  useEffect(() => {
    if (imageBlob && imgRef.current) {
      const renderImage = async () => {
        try {
          const url = URL.createObjectURL(imageBlob);
          imgRef.current.src = url;
        } catch (error) {
          toast.error('Error rendering image');
          console.error(error);
        }
      };
      renderImage();
    }
  }, [imageBlob]);

  const loadProfile = async (mob, doc) => {
    try {

      const formData = { mobileNumber: mob, abbr: doc };
      const response = await axios.post(
        `${BaseUrl}/admin/viewDocument`,
        formData,
        {
          headers: { Authorization: localStorage.getItem('$3ingT0k3n') },
          responseType: 'arraybuffer',
        }
      );
      let contentType = response.headers['content-type'];
      if (!contentType) {
        // Fallback to checking the image data
        const uint = new Uint8Array(response.data);
        contentType = getImageType(uint);
      }

      // Create Blob based on image type
      const imageBlob = new Blob([response.data], { type: contentType });
      setImageBlob(imageBlob); // Setting Blob to state

      //   const applicantData = allData.find((c) => c.mobileNumber === mob);
      //   if (applicantData) {
      setArray({
        //   applicantName: applicantData.applicantName,
        //   applicationStatus: applicantData.applicationStatus,
        //   course: applicantData.course,
        mobileNumber: mob,
      });
      //   }
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
  };

  const getImageType = (uint) => {
    const header = uint[0].toString(16) + uint[1].toString(16);
    switch (header) {
      case '8950': // PNG header
        return 'image/png';
      case 'ffd8': // JPEG header
        return 'image/jpeg';
      default:
        throw new Error('Unsupported image type');
    }
  };


  const saveApplicationStatus = async () => {
    try {
      document.getElementById("sunstatus").disabled = "true";
      const response = await axios.post(
        `${BaseUrl}/admin/saveApplicationStatus`,
        { approveStatus, ...array, ...formData, mobileNumber },
        {
          headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
        }
      );
      if (response.status === 200) {
        toast.success("Application status saved successfully");
        navigate("/SideBar/applications");

      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const imgRef = useRef(null);


  const modalOpen = () => {
    document.getElementById("reject").style.display = "block";
  };

  const modalClose = () => {
    document.getElementById("reject").style.display = "none";
  };


  return (
    <Container
      className="border round py-2"
      style={{
        backgroundColor: "#f6f5f591",
        boxShadow:
          "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        borderRadius: "9px",
      }}
    >
      <h2 style={{ color: "#000dd3", textAlign: "center" }}>Applicant Form</h2>
      <>
        <h5 style={{ color: "#000dd3" }}>Details of 12th Standard or Equivalent</h5>
        <Table
          striped

        >
          <thead>
            <tr>
              <td style={{ width: "30%" }}>Board</td>
              <td style={{ width: "15%" }}>Passing Year</td>
              <td style={{ width: "15%" }}>Passing Month</td>
              <td style={{ width: "20%" }}>12th Roll Number</td>
              <td style={{ width: "20%" }}>Marks Obtained</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{infoData.board}</td>
              <td>{infoData.schoolYear}</td>
              <td>{infoData.schoolMonth}</td>
              <td>{infoData.rollNumber}</td>
              <td>
                {infoData.marksObtained} out of {infoData.totalMarks}
              </td>
            </tr>
          </tbody>
        </Table>
        <h5 style={{ color: "#000dd3", marginTop: "5%" }}>Address Details</h5>
        <table
          className="mb-3"

        >
          <tbody>
            <tr>
              <td style={{ width: "100%" }} colSpan={3}>
                <b>Address:</b> {infoData.address}
              </td>
            </tr>
            <tr>
              <td style={{ width: "33.33%" }}>
                <b>Country:</b> {infoData.country}
              </td>
              <td style={{ width: "33.33%" }}>
                <b>State:</b> {infoData.state}
              </td>
              <td style={{ width: "33.33%" }}>
                <b>District:</b> {infoData.district}
              </td>
            </tr>
          </tbody>
        </table>
        <h5 style={{ color: "#000dd3", marginTop: "5%" }}>Other Details</h5>
        <table

        >
          <tbody>
            <tr>
              <td style={{ width: "50%" }}>
                GJU University Employee/ Ward/ Spouse
              </td>
              <td>{infoData.employee}</td>
            </tr>
          </tbody>
        </table>
        <h5 style={{ color: "#000dd3", marginTop: "5%" }}>
          Document Details
        </h5>
        <Table
          striped

        >
          <thead>
            <tr>
              <td>S. No.</td>
              <td>Document Name</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            {infoData.documentsDto &&
              infoData.documentsDto.map((doc, index) => (
                <tr key={index}>
                  <td style={{ width: "10%" }}>{index + 1}</td>
                  <td style={{ width: "70%" }}>{doc.docName}</td>
                  <td style={{ width: "20%" }}>
                    <a
                      onClick={() => {
                        toggle();
                        loadProfile(mobileNumber, doc.abbr);
                      }}
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                    > View </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        <Row className="m-1">
          <h5 className="text-center">
            Kindly select the button given below to Approve/Reject the
            uploaded document
          </h5>
          <Col md={4}></Col>
          <Col md={4}>
            <FormGroup check>
              <Input
                name="radio1"
                type="radio"
                checked={approveStatus === "approve"}
                onChange={() => {
                  setApproveStatus("approve");
                  setFormData({ ...formData, remarks: "" });
                  modalClose();
                }}
              />
              <Label check>Approve</Label>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup check>
              <Input
                name="radio1"
                type="radio"
                checked={approveStatus === "reject"}
                onChange={() => {
                  setApproveStatus("reject");
                  modalOpen();
                }}
              />
              <Label check>Reject</Label>
            </FormGroup>
          </Col>
        </Row>
        <Input
          id="reject"
          type="textarea"
          style={{ display: "none" }}
          maxLength={"250"}
          placeholder="Enter your reason to reject the Document"
          rows={1}
          value={formData.remarks}
          onChange={(e) =>
            setFormData({ ...formData, remarks: e.target.value })
          }
        />

        <Button id="sunstatus"
          color="success" className="mt-3"
          onClick={saveApplicationStatus}
          style={{ display: 'block', margin: '0 auto' }}  >
          Save
        </Button>

      </>
      <Modal isOpen={modal} toggle={toggle} fullscreen id="Modal2">
        <ModalHeader toggle={toggle}>
          Verification of the Candidate Certificate
        </ModalHeader>

        <ModalBody className="text-center">
          {imageBlob && (
            <img width={'100%'} src={URL.createObjectURL(imageBlob)} alt="Fetched Image" />
          )}
        </ModalBody>

      </Modal>
    </Container>
  );
}
